export const TABLEAU_FIELD_NAMES = {
  booking_start_date: "Booking Start Date",
  booking_end_date: "Booking End Date",
};
